<template>
  <div class="section-price-time">
      <div class="container">
        <div class="row">
          <div class="col-3 price-time__main">
            <div>
              <h2 class="about-project__h2-title color-primary">Verðvakt</h2>
              <p class="price-time__description">Þú getur sett af stað verðvakt sem fylgist með verðbreytingum og lætur þig vita ef verðið á draumabílnum lækkar eða hagstæð tilboð bjóðast.</p>
              <ul class="price-time__list">
                <li class="price-time__list-item text">
                  <span>Þú getur sett af stað verðvakt sem fylgist með verðbreytingum og lætur þig vita ef verðið á draumabílnum lækkar eða hagstæð tilboð bjóðast.</span>
                </li>
              </ul>

              <div class="price-time__features" >
                <div class="price-time__feature color-primary text">
                  <IconNotification/> Vakta leitarskilyrði
                </div>
                <div class="price-time__feature color-primary text">
                  <IconFavorites/> Vista ökutæki í eftirlæti
                </div>
              </div>
            </div>
          </div>
          <div class="col-9 price-time__cards">
            <div class="price-time__blocks-flex">
              <div class="price-time__search-block price-time__block_border-dashed">
                <img :src="`${imgURL}search.jpg`"/>
              </div>
              <div class="price-time__cars-block price-time__block_border-dashed">
                <img :src="`${imgURL}cars.png`"/>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import IconFavorites from "@/components/svg/Favorites.vue";
import IconNotification from "@/components/svg/Notification.vue";
export default {
  components: {
    IconFavorites,
    IconNotification
  },
  props: {
    imgURL: {
      type: String,
      default: ''
    }
  }
}
</script>